/** Shared by the schema guard and the resolver's authoritative check, which reject the same input. */
export function outOfRangeTicketIndexMessage(ticketIndex, ticketCount) {
    return `ticketIndex ${ticketIndex} is out of range for a line with ${ticketCount} planned ${ticketCount === 1 ? 'ticket' : 'tickets'}.`;
}
//# sourceMappingURL=out-of-range-ticket-index-message.js.map